import { h, Component, Host } from '@stencil/core';

/**
 * component used to render examples of all the charts. Mostly used for dev purposes
 */
@Component({
  tag: 'udp-charts-example',
})
export class UdpChartsExample {
  render() {
    return (
      <Host style={{ display: 'flex', flexWrap: 'wrap' }}>
        <udp-donut-chart size="small" kpisPosition='top'/>
        <udp-distribution-chart />
        <udp-bar-chart />
        <udp-line-chart size="large" />
      </Host>
    );
}
}